import React from 'react'

import { string, node } from 'prop-types'

function BusinessAccountFeatureCard({ icon, title, description }) {
  return (
    <div className="business-account__feature">
      {icon}
      <div className="business-account__feature--content">
        <h3 className="business-account__feature--title">{title}</h3>
        <span className="cgt-legacy-text-default">{description}</span>
      </div>
    </div>
  )
}

BusinessAccountFeatureCard.propTypes = {
  icon: node.isRequired,
  title: string.isRequired,
  description: string.isRequired,
}

export default BusinessAccountFeatureCard
